import { SimpleCustomer } from "./Customer";
import { HammerFallOutcome, SimpleHorseForSale } from "./HorseForSale";

export enum PaymentMethod {
    CHEQUE = "CHEQUE",
    CERTIFIED_CHEQUE = "CERTIFIED_CHEQUE",
    CREDIT_CARD = "CREDIT_CARD",
    DEBIT = "DEBIT",
    CASH = "CASH",
    WIRE_TRANSFER = "WIRE_TRANSFER"
}

export const DisbursementPamentMethods = (): Array<PaymentMethod> => [PaymentMethod.CHEQUE, PaymentMethod.WIRE_TRANSFER];

export const PaymentPamentMethods = (): Array<PaymentMethod> => [
    PaymentMethod.CHEQUE,
    PaymentMethod.CERTIFIED_CHEQUE,
    PaymentMethod.CREDIT_CARD,
    PaymentMethod.DEBIT,
    PaymentMethod.CASH
];

export const PaymentMethodFriendlyName = (paymentMethod: PaymentMethod): string => {
    switch (paymentMethod) {
        case PaymentMethod.CHEQUE:
            return "Cheque";
        case PaymentMethod.CREDIT_CARD:
            return "Credit Card";
        case PaymentMethod.DEBIT:
            return "Debit";
        case PaymentMethod.CERTIFIED_CHEQUE:
            return "Certified Cheque";
        case PaymentMethod.CASH:
            return "Cash";
        case PaymentMethod.WIRE_TRANSFER:
            return "Wire Transfer";
        default:
            return "?";
    }
};

// @deprecated We shouldn't need to go the opposite direction.
// TODO (KB): Look into this in more detail
export const PaymentMethodFriendlyNameToUpperCase = (paymentMethod: string): string => {
    switch (paymentMethod) {
        case "Cheque":
            return "CHEQUE";
        case "Credit Card":
            return "CREDIT_CARD";
        case "Certified Cheque":
            return "CERTIFIED_CHEQUE";
        case "Cash":
            return "CASH";
        default:
            return "?";
    }
};

export enum SettlementType {
    DISBURSEMENT = "DISBURSEMENT",
    PAYMENT = "PAYMENT"
}

export const SettlementTypeFriendlyName = (settlementType: SettlementType): string => {
    switch (settlementType) {
        case SettlementType.DISBURSEMENT:
            return "Disbursement";
        case SettlementType.PAYMENT:
            return "Payment";
        default:
            return "?";
    }
};

export enum Currency {
    CAD = "CAD",
    USD = "USD"
}

export const CurrencyFriendlyName = (currency: Currency): string => {
    switch (currency) {
        case Currency.CAD:
            return "CAD";
        case Currency.USD:
            return "USD";
        default:
            return "?";
    }
};

export interface SalesTax {
    id: number;
    name: string;
    rate: number;
}

export interface Account {
    balance: number;
    pastDueBalance: number;
    account: AccountContents;
    settlements: Array<Settlement>;
}

export interface AccountContents {
    invoices: Array<Invoice>;
    payments: Array<Payment>;
    proceeds: Array<Proceeds>;
    disbursements: Array<Disbursement>;
}

export interface Settlement {
    id: number;
    type: SettlementType;
    dateCreated: number;
    // Technically, this is just a line item...
    createdLineItem: Payment | Disbursement | null;
    loggedyBy: SimpleCustomer;
    notes?: string;
}

export interface SettlementItem {
    id: number;
    amountInCents: number;
    debitInvoiceId: number | null;
    creditInvoiceId: number | null;
    paymentProceedsId: number | null;
    disbursementId: number | null;
    settlementId: number | null;
}

export interface AbstractLineItem {
    id: number;
    type: "PAYMENT" | "DISBURSEMENT" | "PROCEEDS" | "INVOICE_LINE_ITEM" | "INVOICE_TAX";
    entryDate: number;
    dateArchived: number | null;
    description: string | null;
    amountInCents: number;
    notes: string | null;
}

export interface Payment extends AbstractLineItem {
    type: "PAYMENT";

    balance: number;
    settlementItems: Array<SettlementItem>;

    currency: Currency;
    paymentMethod: PaymentMethod;

    horsesForSale: Array<SimpleHorseForSale>;
}

export interface Disbursement extends AbstractLineItem {
    type: "DISBURSEMENT";

    balance: number;
    settlementItems: Array<SettlementItem>;

    currency: Currency;
    paymentMethod: PaymentMethod;

    horsesForSale: Array<SimpleHorseForSale>;
}

export interface Proceeds extends AbstractLineItem {
    type: "PROCEEDS";

    balance: number;
    settlementItems: Array<SettlementItem>;

    fromHorseForSale: SimpleHorseForSale | null;
    // NOTE: Temporarily disabled on the backend
    fromHammerFall: HammerFallOutcome | null;
}

export interface InvoiceLineItem extends AbstractLineItem {
    type: "INVOICE_LINE_ITEM";
    entryType: EntryType;
    applicableTaxes: Array<SalesTax>;
}

export interface InvoiceTaxLineItem extends AbstractLineItem {
    type: "INVOICE_TAX";
    tax: SalesTax;
}

export interface Invoice {
    id: number;

    issueDate: number;
    dueDate: number | null;
    dateVoided: number | null;

    description: string | null;
    customerNotes: string | null;
    internalNotes: string | null;

    lineItems: Array<InvoiceLineItem>;
    invoiceTaxes: Array<InvoiceTaxLineItem>;
    settlementItems: Array<SettlementItem>;

    total: number;
    balance: number;

    horseForSaleTag: SimpleHorseForSale | null;
}

export interface EntryType {
    id: number;
    disabled: boolean;
    name: string;
    debitCredit: "DEBIT" | "CREDIT";

    userSelectable: boolean;
    defaultAmount: number;
    defaultDescription: string;
}

export interface AccountPastDue {
    customer: SimpleCustomer;
    account: Account;
}



// WEBPACK FOOTER //
// ./src/model/Financial.ts